/**
 * Fixed Truth and Dare question categories (old/admin/editor.php, old/fetch_question.php).
 * The value is what the questions table's `category` column stores.
 */
export const TRUTH_DARE_CATEGORIES = ["Truth", "Dare"];

/** Case-insensitive match onto a known category ("truth" -> "Truth"); "" if unknown. */
export function normalizeTruthDareCategory(raw) {
  const key = String(raw ?? "").trim().toLowerCase();
  return TRUTH_DARE_CATEGORIES.find((c) => c.toLowerCase() === key) || "";
}
